export default "dist/images/block-feature-overlap.5b3ba0a.png";